import { Button, Tooltip, useToaster } from '@enterprise-ui/canvas-ui-react'
import EnterpriseIcon, { BoxIcon } from '@enterprise-ui/icons'
import apiConfig from '../../../config/'
import { SEARCH_ACTIONS } from '../../../constants/search'

const CasepackActions = ({ selectedItems }) => {
  const toaster = useToaster()
  const selectedTcins = selectedItems?.map((item) => item.tcin, [])
  const redirectToCasepackApp = async () => {
    try {
      const casePackAppBaseUrl = `${window.location.origin}`
      const casepackFullUrl = `${casePackAppBaseUrl}${apiConfig.casePack.managePath}${selectedTcins}`
      window.open(casepackFullUrl, '_self', 'noopener,noreferrer')
    } catch (error) {
      toaster({
        type: 'error',
        heading: 'Error Redirecting to Casepack Application',
        message:
          error.message || 'An unknown error occurred while redirecting.',
      })
    }
  }

  const isCaseBackButtonDisabled =
    selectedItems?.length !== 0 &&
    selectedItems?.length <= SEARCH_ACTIONS.MAX_EDITABLE

  return (
    <>
      <Tooltip
        content={
          selectedItems?.length <= SEARCH_ACTIONS.MAX_EDITABLE
            ? 'Manage Casepacks'
            : 'Manage Casepacks: Max 100'
        }
        location="top"
        data-testid="casepack-tooltip"
      >
        <Button
          type="ghost"
          onClick={redirectToCasepackApp}
          className="button-bg-hover-transparent"
          disabled={!isCaseBackButtonDisabled}
          data-testid="casepack-button"
        >
          <EnterpriseIcon
            icon={BoxIcon}
            size="md"
            className="hc-clr-contrast-weak"
          />
        </Button>
      </Tooltip>
    </>
  )
}

export default CasepackActions
